export const memberNotesKeys = {
  base: ["notes"] as const,
  summary: (patientId: string) => [...memberNotesKeys.base, patientId, "summary"] as const,
};
